import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { OfferId, offers } from './offerData';
type Props = {
  selectedOffer: OfferId;
  onSelect: (offer: OfferId) => void;
  tone?: 'light' | 'dark';
};
export function OfferSelector({
  selectedOffer,
  onSelect,
  tone = 'light'
}: Props) {
  const isDark = tone === 'dark';
  return <div className="grid grid-cols-2 gap-2.5 sm:gap-4" role="radiogroup" aria-label="Elegí tu oferta" data-id="element-18" data-mp="1lyxcfncf9szx">
      {(Object.values(offers) as Array<(typeof offers)[OfferId]>).map(offer => {
      const isSelected = selectedOffer === offer.id;
      const isMegapack = offer.id === 'megapack';
      const baseStyle = isSelected ? isMegapack ? 'border-rose bg-ink text-cream shadow-lg shadow-plum/20' : 'border-ink bg-white text-ink shadow-md shadow-plum/10' : isDark ? 'border-cream/20 bg-cream/5 text-cream/85 hover:border-cream/50' : 'border-rosegold/15 bg-white text-ink hover:border-rosegold/45';
      return <button key={offer.id} type="button" role="radio" aria-checked={isSelected} onClick={() => onSelect(offer.id)} className={`relative min-h-[126px] rounded-2xl border p-3.5 text-left transition-all sm:min-h-[152px] sm:rounded-3xl sm:p-5 ${baseStyle}`} data-id="element-19" data-mp="3rvjy3szn2v6w">
            {offer.badge && <span className={`absolute -top-2 left-1/2 -translate-x-1/2 whitespace-nowrap rounded-full px-2 py-0.5 text-[8px] font-bold uppercase tracking-wider sm:-top-3 sm:px-3 sm:text-[10px] ${isSelected ? 'bg-rose text-white' : 'bg-rose/15 text-rose'}`} data-id="element-20" data-mp="fckeughemao4">
                {offer.badge}
              </span>}
            <div className="flex items-start justify-between gap-1" data-id="element-21" data-mp="jcumryorbb5m">
              <div data-id="element-22" data-mp="2q66iyz96wpi9">
                <p className="font-display text-base font-semibold leading-tight sm:text-xl" data-id="element-23" data-mp="2q7higmvlrb3k">{offer.shortName}</p>
                <p className={`mt-1 text-[10px] leading-tight sm:text-xs ${isSelected && isMegapack ? 'text-cream/70' : isDark ? 'text-cream/65' : 'text-plum/70'}`} data-id="element-24" data-mp="2l8oh1stlbajr">
                  {offer.description}
                </p>
              </div>
              <span className={`flex h-4 w-4 shrink-0 items-center justify-center rounded-full border sm:h-5 sm:w-5 ${isSelected ? 'border-rose bg-rose text-white' : isDark ? 'border-cream/45' : 'border-rosegold/40'}`} data-id="element-25" data-mp="z0a9bj3bgb8y">
                {isSelected && <CheckCircle2Icon className="h-3 w-3" strokeWidth={3} data-id="element-26" data-mp="1d14gxziji86k" />}
              </span>
            </div>
            <div className="absolute inset-x-3.5 bottom-3.5 flex items-end justify-between sm:inset-x-5 sm:bottom-5" data-id="element-27" data-mp="1hrb5y0gyrupc">
              <span className="font-display text-2xl font-semibold leading-none sm:text-3xl" data-id="element-28" data-mp="1mpw7c37yckfd">{offer.price}</span>
              <span className={`text-[10px] line-through sm:text-xs ${isSelected && isMegapack ? 'text-cream/40' : isDark ? 'text-cream/45' : 'text-plum/45'}`} data-id="element-29" data-mp="1qtu5obpgdr7d">
                {offer.originalPrice}
              </span>
            </div>
          </button>;
    })}
    </div>;
}